import { render, staticRenderFns } from "./JdGoodsPriceRecordDialog.vue?vue&type=template&id=39001e3f"
import script from "./JdGoodsPriceRecordDialog.vue?vue&type=script&lang=js"
export * from "./JdGoodsPriceRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./JdGoodsPriceRecordDialog.vue?vue&type=style&index=0&id=39001e3f&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39001e3f')) {
      api.createRecord('39001e3f', component.options)
    } else {
      api.reload('39001e3f', component.options)
    }
    module.hot.accept("./JdGoodsPriceRecordDialog.vue?vue&type=template&id=39001e3f", function () {
      api.rerender('39001e3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jdStore/jdSkuList/components/JdGoodsPriceRecordDialog.vue"
export default component.exports